// extracted by mini-css-extract-plugin
export default {"feedbackContainer":"wM-z","upvoteIcon":"xM-z","downvoteIcon":"yM-z","feedbackIcon":"zM-z"};